export enum InvitationType {
	None = 0,
	Customer = 1,
	Partner = 2,
}
